import Footer from "../Component/Footer";
import MenuBar from "../Component/MenuBar";
import PageBanner from '../Component/PageBanner';
import Sidebar from '../Component/Sidebar';
import { NavLink } from "react-router-dom";

const JanmashtamiParking = () => {
    return (
        <>
            <MenuBar />
            <Sidebar />

            {/* <!-- Page Banner Section --> */}
            <PageBanner title="Janmashtami Parking & Map Guide" current="Parking & Map Guide" crumbs={[{ to: "/USA/Janmashtami", label: "Grand Janmashtami Celebrations" }]} />

            {/* <!--End Banner Section --> */}

            <div className="container">

                <div className="auto-container">
                    <div className="centered">
                        <hr />
                        <h3>Janmashtami 2026 – Parking &amp; Map Guide</h3>
                        <h4 className="text-center" style={{ color: "#666", marginTop: "10px" }}>
                            Friday, September 4th, 2026 &nbsp;|&nbsp; 6:00 PM - Midnight
                        </h4>
                        <h5 className="text-center" style={{ color: "#888", marginTop: "5px" }}>
                            2769 Duluth Hwy, Duluth, GA 30096
                        </h5>
                        <hr />
                    </div>
                </div>

                {/* Parking Information */}
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">
                                    <span className="fa fa-car" style={{ marginRight: "8px", color: "#e87722" }}></span>
                                    Parking Information
                                </h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title purple-border">
                                    <ul className="satsang_list">
                                        <li>
                                            <strong>On-site Parking:</strong> Available for <strong>$15</strong>
                                        </li>
                                        <li>
                                            <strong>Free Parking + Shuttle Service (5–11 pm):</strong> First Baptist Church — shuttle service will be provided to and from the venue.
                                            <br />
                                            <span style={{ color: "#555" }}>📍 3958 Duluth Hwy, GA 30096</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Map Guide */}
                <hr />
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">
                                    <span className="fa fa-map-marker" style={{ marginRight: "8px", color: "#e87722" }}></span>
                                    Venue Map Guide
                                </h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title orange-border">
                                    <figure className="image" style={{ padding: '10px' }}>
                                        <img
                                            src="https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/87797f71_onsite_partiking_fee.png"
                                            alt="Janmashtami Parking Map Guide 2026"
                                            style={{ width: '100%' }}
                                        />
                                        <a
                                            href="https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/87797f71_onsite_partiking_fee.png"
                                            className="lightbox-image overlay"
                                            data-fancybox="gallery-map"
                                        ></a>
                                    </figure>
                                    <br />
                                    <div className="widget-49-meeting-action">
                                        <a
                                            href="https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/87797f71_onsite_partiking_fee.png"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="btn btn-sm btn-flash-border-primary"
                                        >
                                            View Full Map
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Google Maps Direction */}
                <hr />
                <div className="row" style={{ marginBottom: "30px" }}>
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">
                                    <span className="fa fa-location-arrow" style={{ marginRight: "8px", color: "#e87722" }}></span>
                                    Get Directions
                                </h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title purple-border" style={{ paddingLeft: "20px" }}>
                                    <h4>Yugal Kunj</h4>
                                    <p>2769 Duluth Hwy, Duluth, GA 30096</p>
                                    <p><strong>Date:</strong> Friday, September 4th, 2026</p>
                                    <p><strong>Time:</strong> 6:00 PM - Midnight</p>
                                    <br />
                                    <a
                                        href="https://maps.google.com/?q=2769+Duluth+Hwy,+Duluth,+GA+30096"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="btn btn-sm btn-flash-border-primary"
                                    >
                                        Open in Google Maps
                                    </a>
                                    &nbsp;&nbsp;
                                    <NavLink
                                        to="/USA/Janmashtami"
                                        className="btn btn-sm btn-flash-border-primary"
                                    >
                                        ← Back to Event Details
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <Footer />
        </>
    );
};

export default JanmashtamiParking;
